<template>
	<div class="chat-floating-overlays">
		<chat-emotion v-if="emotionMounted" ref="emoBox" @emotion="$emit('emotion', $event)"></chat-emotion>
		<group-member-selector v-if="isGroup && rtcSelectorMounted" ref="rtcSel" :group="group"
			@complete="$emit('invite-ok', $event)"></group-member-selector>
		<right-menu v-if="rightMenuMounted" ref="rightMenu" @select="$emit('select-menu', $event)"></right-menu>
	</div>
</template>

<script>
import RightMenu from "../common/RightMenu.vue";
import GroupMemberSelector from "../group/GroupMemberSelector.vue";
import ChatEmotion from "./ChatEmotion.vue";

export default {
	name: "chatFloatingOverlays",
	components: {
		RightMenu,
		GroupMemberSelector,
		ChatEmotion
	},
	props: {
		group: {
			type: Object,
			default: () => ({})
		},
		isGroup: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			emotionMounted: false,
			rtcSelectorMounted: false,
			rightMenuMounted: false
		};
	},
	methods: {
		ensureMounted(key) {
			if (!this[key]) {
				this[key] = true;
				return this.$nextTick();
			}
			return Promise.resolve();
		},
		openEmotion(pos) {
			return this.ensureMounted('emotionMounted').then(() => {
				if (this.$refs.emoBox) this.$refs.emoBox.open(pos);
			});
		},
		closeEmotion() {
			if (this.$refs.emoBox) {
				this.$refs.emoBox.close();
			}
		},
		refreshCustomStickers() {
			if (this.$refs.emoBox && this.$refs.emoBox.refreshCustomStickers) {
				this.$refs.emoBox.refreshCustomStickers();
			}
		},
		openRightMenu(pos, items) {
			return this.ensureMounted('rightMenuMounted').then(() => {
				if (this.$refs.rightMenu) this.$refs.rightMenu.open(pos, items);
			});
		},
		openRtcSelector(maxSize, checkedIds, lockedIds, hideIds) {
			return this.ensureMounted('rtcSelectorMounted').then(() => {
				if (this.$refs.rtcSel) this.$refs.rtcSel.open(maxSize, checkedIds, lockedIds, hideIds);
			});
		}
	}
}
</script>
